<template>
  <div class="hello">
    <van-nav-bar
      style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
      title=""
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    >
      <template #title>
        <span style="color: white; font-size: 0.4rem">添加学生</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" color="white" size="18" />
      </template>
    </van-nav-bar>
    <van-form class="van-form" style="margin-top: 20px" @submit="onSubmit">
      <van-field
        readonly
        clickable
        name="xiaoqu"
        :value="xiaoqu"
        label="选择学校"
        placeholder="请选择所属学校"
        @click="showPicker = true"
        style="margin-top: 20px"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="schoolName"
          @confirm="onConfirm1"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="username"
        label="姓名"
        name="username"
        placeholder="请输学生姓名"
        :rules="[{ required: true, message: '请输学生姓名', placeholder: '' }]"
      />
      <van-field
        v-model="number"
        label="学号"
        name="number"
        placeholder="请输入学号"
        :rules="[{ required: true, message: '请输入学号', placeholder: '' }]"
      />
      <van-field
        v-model="phone"
        label="学生密码"
        name="phone"
        placeholder="请输入学生密码"
        :rules="[
          { required: true, message: '请输入学生密码', placeholder: '' },
        ]"
      />
      <div style="margin: 16px; margin-top: 40px">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      phone: "",
      number: "",
      xiaoqu: "",
      xiaoquid: "",
      page: "",
      student: "",
      columns: [],
      showPicker: false,
    };
  },
  created() {
    this.student = this.$route.query.student;
    this.page = this.$route.query.page;
    this.xiaoqu = this.$route.query.xiaoqu;
    console.log(
      "传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page
    );
    var params_json = {
      userid: "",
      action: "schoolList",
      param1: "",
      param2: "",
      param3: "",
      param4: "",
      param5: "",
    };
    // console.log(params_json);
    let _this = this;
    this.$http.post("/web/list", params_json).then(function (res) {
      console.log(res.data["rows"]);
      _this.columns = res.data["rows"];
    });
  },
  methods: {
    onConfirm1(value) {
      console.log(value);
      this.xiaoqu = value.schoolName;
      this.xiaoquid = value.schoolId;
      this.showPicker = false;
    },
    onSubmit(values) {
      this.student = this.$route.query.student;
      this.page = this.$route.query.page;
      console.log("submit", values);
      var json = window.localStorage.getItem("User");
      var jsonObj = JSON.parse(json);
      console.log("身份:" + jsonObj[0]["shenfen"]);
      var code;
      if (jsonObj[0]["shenfen"] == "老师") {
        code = jsonObj[0]["number"];
      } else if (jsonObj[0]["shenfen"] == "学生") {
        code = jsonObj[0]["number"];
      } else {
        code = jsonObj[0]["phone"];
      }
      var params_json = {
        userid: code,
        action: "parentStudentBind",
        param1: values.number,
        param2: values.username,
        param3: this.xiaoqu,
        param4: this.xiaoquid,
        param5: "",
        // param4:this.openId
      };
      this.$http.post("/web/save", params_json).then(function (res) {
        let obj = res.data;
        console.log("注册后返回消息:" + obj.msg);
        if (obj.msg == "0") {
          this.$notify({
            type: "success",
            message: "注册成功。",
          });
          setTimeout(() => {
            this.$router.push("StudentIndex");
          }, 3000);
        } else {
          this.$notify({
            type: "warning",
            message: obj.msg,
          });
          // location.reload();
        }
      });
    },
    onClickLeft() {
      this.$router.push({
        path: "StudentIndex",
        query: {
          student: this.student,
          xiaoqu: this.xiaoqu,
          page: this.page,
        },
      });
    },
    onClickRight() {
      // 危险通知
      this.$toast("失败文案");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.van-doc-demo-block__title {
  margin: 0;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 0.4rem;
  line-height: 16px;
  font-weight: bold;
}

.van-doc-demo-block__card {
  margin: 12px 12px 0;
  overflow: hidden;
  border-radius: 8px;
}

.van-doc-demo-block__title + .van-doc-demo-block__card {
  margin-top: 0;
}

.van-doc-demo-block:first-of-type .van-doc-demo-block__title {
  padding-top: 20px;
}
</style>
<style>
.demo-col {
  background: #fff;
}

.demo-col .van-doc-demo-block {
  padding: 0 16px;
}

.demo-col .van-doc-demo-block__title {
  padding-left: 0;
}

.demo-col .van-col {
  margin-bottom: 10px;
  color: #fff;
  font-size: 0.4rem;
  line-height: 30px;
  text-align: center;
  background-clip: content-box;
}

.demo-col .van-col:nth-child(odd) {
  background-color: #39a9ed;
}

.demo-col .van-col:nth-child(even) {
  background-color: #66c6f2;
}
</style>